import { Component, OnDestroy, OnInit } from '@angular/core';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Subscription } from 'rxjs';

import { BlockedSlotInfoModel } from '@bayclubs/court-booking-employee-api';

import { CancelCourtEventLauncherService } from '@court-event-modals/court-event-modals.module';
import { CourtEventNoteSaveLauncherService, SaveCourtEventNoteSuccessAction } from '@court-event-note-save/court-event-note-save.module';
import { CourtEventStatus } from '@shared-models/shared-models.module';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { CourtEventInfoFacade } from './../../+store/court-event-info.facade';

@Component({
    selector: 'app-blocked-slot-info-details',
    templateUrl: './blocked-slot-info-details.component.html',
    styleUrls: ['./blocked-slot-info-details.component.scss'],
    standalone: false
})
export class BlockedSlotInfoDetailsComponent implements OnInit, OnDestroy {
    blockedSlot$ = this.courtEventInfoFacade.blockedSlotDetails$;
    spinner$ = this.courtEventInfoFacade.spinner$;

    public blockedSlotId: string;

    private subscriptions: Subscription = new Subscription();

    constructor(private courtEventInfoFacade: CourtEventInfoFacade,
        private cancelLauncher: CancelCourtEventLauncherService,
        private courtEventNoteSaveLauncherService: CourtEventNoteSaveLauncherService,
        private actions$: Actions,
        private readonly modalRef: BsModalRef) { }

    ngOnInit(): void {
        this.courtEventInfoFacade.loadBlockedSlotDetails(this.blockedSlotId);

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(SaveCourtEventNoteSuccessAction)).subscribe(() => {
                this.courtEventInfoFacade.loadBlockedSlotDetails(this.blockedSlotId);
            })
        );
    }

    ngOnDestroy(): void {
        this.courtEventInfoFacade.clearLoadedBlockedSlot();

        this.subscriptions.unsubscribe();
    }

    close(): void {
        this.modalRef.hide();
    }

    cancel() {
        const blockedSlot = this.courtEventInfoFacade.getBlockedSlotDetailsSnapshot();

        this.cancelLauncher.openCancelCourtBlockedSlotModal(
            { blockedSlotId: blockedSlot.data.blockedSlotId, isRecurring: blockedSlot.data.recurring !== null },
            () => this.courtEventInfoFacade.loadBlockedSlotDetails(this.blockedSlotId)
        );
    }

    edit() { }

    details() {
        this.courtEventInfoFacade.goToBlockedSlotDetails(this.blockedSlotId);
        this.close();
    }

    onAddNote(): void {
        this.courtEventNoteSaveLauncherService.openCourtNoteSave({ courtEventId: this.blockedSlotId });
    }

    public isCancellationAvailable(blockedSlot: BlockedSlotInfoModel) {
        return blockedSlot.isCancellationAvailable && blockedSlot.status.code === CourtEventStatus.confirmed.code;
    }
}
